import React from 'react';

interface RulesPreviewPageProps {
  urlPDF: string
}

const PreviewPDF: React.FC<RulesPreviewPageProps> = ({
  urlPDF
}) => <iframe 
  src={`${urlPDF}#toolbar=0&&zoom=120`} 
  style={{ 
    width: '100%', 
    height: '100%',
    border: 'none',
    display: 'block'
  }} 
/>;

export default PreviewPDF;
